import { DataLoaderParams } from '@/types/DataLoaderParams';
import { fetchAllSellersIfNeeded } from '@/redux/modules/seller';

export default ({ store }: DataLoaderParams) => {
    const { dispatch } = store;
    return dispatch(fetchAllSellersIfNeeded());
};
